import { render, staticRenderFns } from "./SingleReturnModal.vue?vue&type=template&id=368929bc&"
import script from "./SingleReturnModal.vue?vue&type=script&lang=js&"
export * from "./SingleReturnModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SingleReturnModal.vue"
export default component.exports